import { render, staticRenderFns } from "./PoiMapPage.vue?vue&type=template&id=926325d8&scoped=true&"
import script from "./js/poi-map-page.js?vue&type=script&lang=js&"
export * from "./js/poi-map-page.js?vue&type=script&lang=js&"
import style0 from "./PoiMapPage.vue?vue&type=style&index=0&id=926325d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926325d8",
  null
  
)

export default component.exports